module.exports = __webpack_public_path__ + "img/zhys_zhCn.1cf5e46b.png";